// @flow
import * as React from 'react';
import {
    EmailAddressField,
    EmailAddressConfirmField,
    UsernameField,
    PasswordField,
    PasswordConfirmField,
    LocaleField,
    ContactLocaleField,
    SendConfirmEmailField,
    MerchantField
} from '../field';
import Buttons from '../button';

type UserComponentProps = {
    networkName: string,
    merchantId?: ?string
};

const UserComponent = ({ networkName, merchantId }: UserComponentProps) => (
    <form>
        <ContactLocaleField />
        <LocaleField />
        <SendConfirmEmailField />
        
        <EmailAddressField />
        <EmailAddressConfirmField />
        <UsernameField />
        <PasswordField />
        <PasswordConfirmField />
        { merchantId && networkName === 'paypalmerchant' ?  
            <MerchantField merchantId={merchantId} /> : null
        }
        <Buttons login />
    </form>
);

export default UserComponent;
